/**
 * "INCLUIR SUGESTÕES DA IA" (25/10/2026, decisão do pesquisador) — a escolha de quem lê os relatórios por habilidade:
 * somar à conta a habilidade só SUGERIDA pela IA, marcada. A regra é do servidor (`services/sugestoesNaConta.ts`); aqui
 * mora só a escolha, que viaja em todo pedido como `?sugestoes=1` (o `if` é o interceptador de `api.ts`).
 *
 * Desligada por padrão e só na SESSÃO do navegador, pela razão do "só a janela original" (`escolhaDeReabertas.ts`): um
 * interruptor esquecido ligado faria o número mudar sem ninguém saber por quê.
 */
const CHAVE = 'relatorios:incluir-sugestoes-da-ia';

export function sugestoesDaIALigadas(): boolean {
  try { return sessionStorage.getItem(CHAVE) === '1'; } catch { return false; }
}
export function ligarSugestoesDaIA(ligado: boolean): void {
  try { if (ligado) sessionStorage.setItem(CHAVE, '1'); else sessionStorage.removeItem(CHAVE); } catch { /* sem armazenamento: fica desligado */ }
}
